import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.png';
import '../css/webPanel/WebSidebar.css';

const WebSidebar = ({isWebAdmin}) => {
        const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);
 
            const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    const handleLogout = () => {
        localStorage.removeItem('userData');
        if(isWebAdmin) {
        localStorage.removeItem('isWebAdmin', 'true');
        navigate('/school-login');
        }
        window.location.reload();
    }

  return (
    <>
                  <div className={`sidebar-area ${collapsed ? "" : "collapsed"}`}>

                <div className='my-4 sidebar-logo-area'>
                    <img src={Logo} className='sidebar-logo' alt='Logo Sidebar' />
<p className='align-content-center fw-bold my-0 ms-2 sidebar-logo-text'>KC Public School</p>
                </div>

{isWebAdmin && (
                    <div className='text-center mt-4'>
                        <p className='sidebar-item my-3' onClick={() => { navigate('/web-dashboard'); setCollapsed(false) }}><i class="fa-solid fa-chart-pie"></i><Link className='sidebar-text'>Dashboard</Link></p>
                        <p className='sidebar-item my-3' onClick={() => { navigate('/notice-board'); setCollapsed(false) }}><i class="fa-regular fa-clipboard"></i><Link className='sidebar-text'>Notice Board</Link></p>
                        <p className='sidebar-item my-3' onClick={() => { navigate('/achievements'); setCollapsed(false) }}><i class="fa-solid fa-graduation-cap"></i><Link className='sidebar-text'>Achievements</Link></p>
                        <p className='sidebar-item my-3' onClick={() => { navigate('/blog-post'); setCollapsed(false) }}><i class="fa-solid fa-blog"></i><Link className='sidebar-text'>Blog Post</Link></p>
                        {/* <p className='sidebar-item my-3' onClick={() => { navigate('/alumni-posts'); setCollapsed(false) }}><i class="fa-regular fa-envelope"></i><Link className='sidebar-text'>Alumni Blogs</Link></p> */}
                        <p className='sidebar-item my-3' onClick={() => { setShowLogout(true) }}><i class="fa-solid fa-power-off"></i><Link className='sidebar-text'>Log Out</Link></p>

                                <span className="sidebar-btn2 py-2 px-4" onClick={toggleSidebar}>
                    <i className={`fa-solid ${collapsed ? "fa-angle-right" : "fa-angle-left"}`}></i>
                </span>
</div>
)}

                </div>

                            {showLogout && (
                                
                <section className='dialog-outer' onClick={() => setShowLogout(false)}>
                    <div className='dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='page-heading'>Really want to Log Out?</p>

                        <button className='notice-btn2 me-2' onClick={() => handleLogout()}>Yes</button>
                        <button className='notice-btn2 bg-secondary' onClick={() => setShowLogout(false)}>No</button>

                    </div>
                </section>
            )}
    </>
  )
}

export default WebSidebar
